// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","container":"_2PDqL9UB6b8B5PUnrjrYwE","text":"_3E7puhoiX4XSSu9sdh28sE","support":"_1tN5pwaTraGWnJzWd8FMIm","label":"_3x1AcJUSxnpADJPAX2fciQ","year-select":"_2NrPZN2RNWxdRDZ8uyL9FA"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UserProfile/UserProfile.mod.css
// module id = 373
// module chunks = 0